import { render } from "./featureCollection.vue?vue&type=template&id=2c3ca979"
import script from "./featureCollection.vue?vue&type=script&lang=js"
export * from "./featureCollection.vue?vue&type=script&lang=js"

import "./featureCollection.vue?vue&type=style&index=0&id=2c3ca979&lang=scss"

import exportComponent from "/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__